import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserManual, UserManualService } from '../services/user-manual.service';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.scss'],
})
export class UserManualComponent {
  searchTerm = '';

  manuals: UserManual[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly userManualService: UserManualService
  ) {
    this.userManualService.getUserManuals().subscribe({
      next: (manuals) => {
        this.manuals = manuals.data;
      },
    });
  }

  get filteredManuals() {
    if (!this.searchTerm) return this.manuals;

    const terms = this.searchTerm.toLowerCase().split(/\s+/);

    return this.manuals.filter((m) => {
      const haystack = (m.title + ' ' + m.keywords.join(' ')).toLowerCase();

      return terms.every((t) => haystack.includes(t));
    });
  }

  getSrcImageByType(type: string) {
    switch (type) {
      case 'cloud':
        return 'assets/img/user-manual/cloud.png';
      case 'CityMesh Communicator':
        return 'assets/img/user-manual/cityMeshCommunicator.png';
      case 'CityAlarm Tech':
        return 'assets/img/user-manual/cityAlarmTech.png';
      case 'CityMesh Panel':
        return 'assets/img/user-manual/cityMeshPanel.png';
      case 'CityAlarm Costumer':
        return 'assets/img/user-manual/cityAlarmCustomer.png';
      default:
        return 'assets/img/user-manual/default.png';
    }
  }

  getTranslatedLanguage(language: string): string {
    switch (language) {
      case 'en':
        return this.translateService.instant('AppComponent.LanguageEnglish');
      case 'es':
        return this.translateService.instant('AppComponent.LanguageSpanish');
      case 'pt':
        return this.translateService.instant('AppComponent.LanguagePortuguese');
    }
  }

  openManual(link: string) {
    if (link) {
      window.open(link, '_blank');
    }
  }

  downloadManual(manual: UserManual) {
    this.userManualService.downloadUserManual(manual._id).subscribe((file: Blob) => {
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = manual.title + '.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
